var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.marketingDomainItemClasses },
    [
      !_vm.domain.isValidated
        ? [
            _c(
              "div",
              { staticClass: "marketing-domain-item__input" },
              [
                _c(
                  "CompassFormItem",
                  {
                    staticClass: "inputDomainName",
                    attrs: {
                      label: _vm.$t.__(
                        "pages.account.upsell.marketing.ChargebeeUpsellMarketingDomainsItem.domain_name"
                      )
                    }
                  },
                  [
                    _c("CompassInput", {
                      attrs: { value: _vm.domain.name, placeholder: "" },
                      on: {
                        "update:value": _vm.onUpdateNameDomain,
                        keypress: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar"
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "CompassSelect",
                  {
                    attrs: { value: _vm.domain.extension },
                    on: { "update:value": _vm.onUpdateExtensionDomain }
                  },
                  _vm._l(_vm.listDomainExtensions, function(extension) {
                    return _c("CompassDropdownSelectOption", {
                      key: extension.value,
                      attrs: { label: extension.label, value: extension.value }
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c("CompassPlainButton", {
                  attrs: {
                    disabled: !_vm.domain.sender,
                    label: _vm.$t.__(
                      "pages.account.upsell.marketing.ChargebeeUpsellMarketingDomainsItem.check_availability"
                    ),
                    loading: _vm.domainCheckLoading
                  },
                  on: { click: _vm.checkDomain }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.domainAvailabilityStatus ===
            _vm.EnumDomainAvailabilityStatus.AVAILABLE
              ? _c(
                  "div",
                  { staticClass: "marketing-domain-item__availability" },
                  [
                    _c("CompassIcon", {
                      staticClass:
                        "marketing-domain-item__availability-icon marketing-domain-item__availability-icon--success",
                      attrs: { icon: "success-circle-fill", type: "success" }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "typographies-paragraph-medium-semibold marketing-domain-item__availability-label"
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$l10n.__("Disponible")) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__(
                          "pages.account.upsell.marketing.ChargebeeUpsellMarketingDomainsItem.select_domain_name"
                        )
                      },
                      on: { click: _vm.onUpdateIsValidated }
                    })
                  ],
                  1
                )
              : _vm.domainAvailabilityStatus ===
                _vm.EnumDomainAvailabilityStatus.UNAVAILABLE
              ? _c(
                  "div",
                  { staticClass: "marketing-domain-item__availability" },
                  [
                    _c("CompassIcon", {
                      staticClass: "marketing-domain-item__availability-icon",
                      attrs: { icon: "warning-fill", type: "warning" }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "typographies-paragraph-medium-semibold marketing-domain-item__availability-label"
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$l10n.__("Indisponible")) +
                            "\n            "
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        : _c("div", [
            _c(
              "div",
              { staticClass: "validated-title" },
              [
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-medium-semibold" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.domain.sender) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.delete"),
                    leftIcon: "bin",
                    type: "tertiary-destructive"
                  },
                  on: { click: _vm.onRemoveDomain }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "email-redirect" }, [
              _c(
                "span",
                { staticClass: "typographies-paragraph-medium-semibold" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$l10n.__("Sous domaine")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "email-redirect-input" },
                [
                  _c("CompassInput", {
                    attrs: { value: _vm.domain.subDomain, placeholder: "" },
                    on: {
                      "update:value": _vm.onUpdateSubDomain,
                      keypress: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "space", 32, $event.key, [
                            " ",
                            "Spacebar"
                          ])
                        ) {
                          return null
                        }
                        $event.preventDefault()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "typographies-paragraph-medium-semibold" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s("." + _vm.domain.sender) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "typographies-paragraph-small-regular email-redirect-description"
                },
                [
                  _c("p", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$l10n.__("Une fois votre achat validé :")) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("ul", [
                    _c("li", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$l10n.__(
                              "le sous-domaine sera exclusivement réservé au suivi des ouvertures et clics"
                            )
                          ) +
                          "\n                    "
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$l10n.__(
                              "vous pourrez ajouter vos adresses d’envoi (utilisant votre domaine) dans Sellsy Marketing à la rubrique Plus > Paramètres > Emailing > Adresse(s) email(s) d’envoi."
                            )
                          ) +
                          "\n                    "
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$l10n.__(
                              "il vous faudra attendre 48h avant pouvoir profiter de votre domaine et débuter les envois d’emails."
                            )
                          ) +
                          "\n                    "
                      )
                    ])
                  ])
                ]
              )
            ])
          ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }